module.exports = __webpack_public_path__ + "static/media/new_banner.8cae4b81.jpeg";